export const BOOST_MAX = 100;
export const BOOST_START = 28;
/** Small pad in a cluster of 5. Four of them plus driving fill most of the tank. */
export const BOOST_SMALL = 24;
export const BOOST_DRAIN_PER_SEC = 36;
export const BOOST_ACCEL = 24;
/** Added on top of the surface max speed while nitro is firing. */
export const BOOST_EXTRA_SPEED = 8.5;
